<template>
  <section id="section8">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-4">
              <h1 class="section-title font-weight-light">Часто задаваемые вопросы</h1>
            </div>
          </v-col>
          <v-col cols="12" md="9" xl="9" class="mt-6 mb-6 section1-cards" style="padding-left: 0; padding-right: 0;">
            <v-row>
              <v-col cols="12" md="12" offset-lg="2" lg="8" xs="12">
                <v-expansion-panels accordion>
                  <v-expansion-panel
                      v-for="(item,i) in items"
                      :key="i"
                  >
                    <v-expansion-panel-header>{{ item.title }}</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <p v-html="item.text"></p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>


<script>

export default {
  data: () => ({
    items: [
      {
        title: 'Как передать документы для подготовки?',
        text: 'Вы можете отправить фотографии или скан-копию документов любым удобным способом: <a href="mailto:NALOG-SERVICE@INTERNET.RU" target="_blank">электронная почта</a>, мессенджеры (<a href="https://wa.me/79127916470" target="_blank">WhatsApp</a>, <a href="viber://chat?number=%2B79127916470" target="_blank">Viber</a> и <a href="https://t.me/+79127916470" target="_blank">Telegram</a>).'
      },
      {
        title: 'Сколько времени занимает подготовка документов?',
        text: 'Срок подготовки документов – в течение 3 рабочих дней с момента получения всех запрошенных документов.'
      },
      {
        title: 'Как и когда оплачивать?',
        text: 'Оплата производится по факту готовности документов. Наш специалист направляет вам готовые документы и ссылку на оплату. Оплатить можно онлайн (картами МИР, Visa, Mastercard, Maestro, SberPay, Тинькофф, Альфа-клик и др.) или наличными в терминалах города, салонах Связной, любом банкомате Сбербанка.'
      },
      {
        title: 'Что такое гарантия качества услуг?',
        text: 'В случае возвращения документов Налоговой службой с замечаниями мы бесплатно выполняем все корректировки, а в случае невозможности исправления – возвращаем деньги.'
      },
      {
        title: 'Как я получу готовые документы?',
        text: 'Готовый пакет документов отправляем вам любым удобным способом: <a href="mailto:NALOG-SERVICE@INTERNET.RU" target="_blank">электронная почта</a>,\n' +
            'мессенджеры (<a href="https://wa.me/79127916470" target="_blank">WhatsApp</a>, <a href="viber://chat?number=%2B79127916470">Viber</a> и <a href="https://t.me/+79127916470" target="_blank">Telegram</a>). Предоставляем пошаговую инструкцию по сдаче\n' +
            'документов в налоговую инспекцию лично, по почте, через личный кабинет налогоплательщика\n' +
            'или портал Госуслуги.'
      },
      // {
      //   title: 'Что будет с моими персональными данными?',
      //   text: 'Мы аккредитованы Роскомнадзором как оператор персональных данных, имеем право хранить и обрабатывать ваши персональные данные. Все полученные\n' +
      //       'документы хранятся на специальных серверах, которые отвечают всем требованиям ФЗ №152 «О\n' +
      //       'персональных данных».'
      // },
      {
        title: 'Если налоговая найдет ошибку в декларации 3-НДФЛ?',
        text: ' Все подготовленные документы проходят двух этапную проверку:\n' +
            '<ol>\n' +
            '    <li>Проверка полноты представления документов и обоснованности заявленных налоговых\n' +
            'вычетов.</li>\n' +
            '    <li>Арифметический контроль подсчета данных в декларации, визуальная проверка правильности\n' +
            'оформления документов – полнота и четкость заполнения всех необходимых реквизитов.</li>\n' +
            '</ol>\n' +
            'Если в ходе камеральной проверки будут выявлены ошибки, допущенные по нашей вине, мы\n' +
            'бесплатно внесем исправления в подготовленные документы или вернем полную стоимость\n' +
            'услуг. '
      },
      {
        title: 'Если налоговая откажет в налоговом вычете?',
        text: 'Персональный консультант сопровождает клиента до момента завершения камеральной проверки и зачисления денежных средств на счет. В случае отказа в предоставлении налогового вычета по нашей вине, вернем полную стоимость услуг. Если, по мнению эксперта, отказ неправомерный, поможем обжаловать решение налогового органа.'
      },
    ]
  }),
};
</script>

<style lang="scss">
.v-expansion-panel-header{
  color: #005096;
  font-weight: 500 !important;
}
</style>